import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../Dashboard.css";
import CompanyAvatar from "../../UILibrary/CompanyAvatar";
import { searchMoreRecSuppliers } from "../../../store/rfpSlice";

const GalleryOfSuppliers = ({
  onCardClick,
  isRecommendedSuppliersLoaded,
  isMoreSuppliersClicked,
  setMoreSuppliersClicked,
  isSearchInProgress,
  searchQuery,
  clearSearch,
}) => {
  const { summaryText, moreRecSuppliers, searchSuppliers } = useSelector(
    (state) => state.rfp
  );
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
  const suppliers = useSelector(
    (state) => state?.marketplaceSuppliers?.suppliers
  );
  const recommendedSuppliers = useSelector((state) => state.rfp?.recSuppliers);
  const dispatch = useDispatch();

  const handleOpenMoreSuppliers = () => {
    dispatch(
      searchMoreRecSuppliers({
        text: summaryText || searchQuery,
        page: 2,
        pageSize: 50,
      })
    );
    setMoreSuppliersClicked(true);
  };


  const suppliersToDisplay = isSearchInProgress
    ? searchSuppliers
    : isRecommendedSuppliersLoaded
    ? recommendedSuppliers
    : suppliers;

  const suppliersGallery = suppliersToDisplay.map((supplier, index) => (
    <div
      key={index}
      onClick={() => onCardClick(supplier)}
      className="relative border rounded-lg flex flex-col items-center p-4 pt-8 shadow-sm hover:shadow-lg cursor-pointer transition h-[410px]"
    >
      {(isRecommendedSuppliersLoaded || isSearchInProgress) && (
        <div className="absolute top-4 right-2 flex flex-col items-end">
          <div className="bg-[#EAF524] text-black font-semibold text-base px-4 py-2 rounded-lg">
            <span
              onMouseEnter={() => setHoveredCardIndex(index)}
              onMouseLeave={() => setHoveredCardIndex(null)}
            >
              {(supplier?.similarity * 100).toFixed(1)} %
            </span>
          </div>
          {hoveredCardIndex === index && (
            <div className="absolute -right-2 -bottom-5 flex w-[167px] h-[31px] items-center justify-center rounded-md bg-[rgba(1,1,1,0.77)] px-[10px] py-[7px]">
              <span className="text-white font-lato text-[9px] font-normal leading-none w-[148px]">
                The percentage at which the supplier matches your specifications
              </span>
            </div>
          )}
        </div>
      )}

      {/* Avatar */}
      <div className="my-5">
        <CompanyAvatar
          companyName={supplier?.company?.name || ""}
          size="58px"
        />
      </div>

      {/* Company name */}
      <p className="text-[#1D2739] text-lg font-medium">
        {supplier?.company?.name}
      </p>

      {/* Industry + Location */}
      <div className="flex flex-col mb-2 text-gray-600">
        <p className="mb-2">{supplier?.industry?.name}</p>
        <p>
          {(() => {
            const location = supplier?.address?.type?.[0];
            if (!location) return "";
            return [location.city, location.state, location.country]
              .filter(Boolean)
              .join(", ");
          })()}
        </p>
      </div>

      {/* Rating + Certified */}
      <div className="flex items-center justify-center mb-6">
        <p className="mr-2 text-gray-500">Rating:</p>
        <p className="ml-2 bg-[#EAF524] rounded px-3 py-1 text-sm whitespace-nowrap">
          {"No rating yet"}
        </p>
        {supplier?.diversity?.certificationType?.length > 0 && (
          <span className="flex items-center justify-center ml-2">
            <svg
              className="ml-4 mr-1"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clip-path="url(#clip0_180_62016)">
                <mask
                  id="mask0_180_62016"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="16"
                >
                  <path
                    d="M8.00066 14.6663C8.87629 14.6674 9.74351 14.4955 10.5525 14.1604C11.3615 13.8253 12.0963 13.3336 12.7147 12.7137C13.3346 12.0953 13.8263 11.3605 14.1614 10.5515C14.4965 9.74254 14.6684 8.87532 14.6673 7.99968C14.6684 7.12404 14.4965 6.25682 14.1614 5.44784C13.8263 4.63886 13.3346 3.90407 12.7147 3.28568C12.0963 2.66573 11.3615 2.17409 10.5525 1.83898C9.74351 1.50388 8.87629 1.33193 8.00066 1.33301C7.12502 1.33193 6.2578 1.50388 5.44882 1.83898C4.63984 2.17409 3.90505 2.66573 3.28666 3.28568C2.66671 3.90407 2.17506 4.63886 1.83996 5.44784C1.50486 6.25682 1.33291 7.12404 1.33399 7.99968C1.33291 8.87532 1.50486 9.74254 1.83996 10.5515C2.17506 11.3605 2.66671 12.0953 3.28666 12.7137C3.90505 13.3336 4.63984 13.8253 5.44882 14.1604C6.2578 14.4955 7.12502 14.6674 8.00066 14.6663Z"
                    fill="white"
                    stroke="white"
                    stroke-width="1.33333"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.33398 8L7.33398 10L11.334 6"
                    stroke="black"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </mask>
                <g mask="url(#mask0_180_62016)">
                  <path
                    d="M0.000976562 0H16.001V16H0.000976562V0Z"
                    fill="#0088FF"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_180_62016">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.000976562)"
                  />
                </clipPath>
              </defs>
            </svg>
            <p className="text-blue-500 text-sm">Certified</p>
          </span>
        )}
      </div>

      {/* About */}
      <div className="w-full flex flex-col items-start text-left">
        <p className="font-semibold">About</p>
        <p className="text-gray-500 line-clamp-3 sm:line-clamp-4">
          {supplier?.company?.description || ""}
        </p>
      </div>
    </div>
  ));

  const moreSupplierstoExplore = moreRecSuppliers.map((supplier, index) => (
    <div
      key={index}
      onClick={() => onCardClick(supplier)}
      className="relative border rounded-lg flex flex-col items-center p-4 pt-8 shadow-sm hover:shadow-lg cursor-pointer transition h-[410px]"
    >
      <div className="absolute top-4 right-2 flex flex-col items-end">
        <div className="bg-[#EAF524] text-black font-semibold text-base px-4 py-2 rounded-lg">
          <span
            onMouseEnter={() => setHoveredCardIndex(index)}
            onMouseLeave={() => setHoveredCardIndex(null)}
          >
            {(supplier?.similarity * 100).toFixed(1)} %
          </span>
        </div>
        {hoveredCardIndex === index && (
          <div className="absolute -right-2 -bottom-5 flex w-[167px] h-[31px] items-center justify-center rounded-md bg-[rgba(1,1,1,0.77)] px-[10px] py-[7px]">
            <span className="text-white font-lato text-[9px] font-normal leading-none w-[148px]">
              The percentage at which the supplier matches your specifications
            </span>
          </div>
        )}
      </div>

      {/* Avatar */}
      <div className="my-5">
        <CompanyAvatar
          companyName={supplier?.company?.name || ""}
          size="58px"
        />
      </div>

      {/* Company name */}
      <p className="text-[#1D2739] text-lg font-medium">
        {supplier?.company?.name}
      </p>

      {/* Industry + Location */}
      <div className="flex flex-col mb-2 text-gray-600">
        <p className="mb-2">{supplier?.industry?.name}</p>
        <p>
          {(() => {
            const location = supplier?.address?.type?.[0];
            if (!location) return "";
            return [location.city, location.state, location.country]
              .filter(Boolean)
              .join(", ");
          })()}
        </p>
      </div>

      {/* Rating + Certified */}
      <div className="flex items-center justify-center mb-6">
        <p className="mr-2 text-gray-500">Rating:</p>
        <p className="ml-2 bg-[#EAF524] rounded px-3 py-1 text-sm whitespace-nowrap">
          {"No rating yet"}
        </p>
        {supplier?.diversity?.certificationType?.length > 0 && (
          <span className="flex items-center justify-center ml-2">
            <svg
              className="ml-4 mr-1"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clip-path="url(#clip0_180_62016)">
                <mask
                  id="mask0_180_62016"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="16"
                >
                  <path
                    d="M8.00066 14.6663C8.87629 14.6674 9.74351 14.4955 10.5525 14.1604C11.3615 13.8253 12.0963 13.3336 12.7147 12.7137C13.3346 12.0953 13.8263 11.3605 14.1614 10.5515C14.4965 9.74254 14.6684 8.87532 14.6673 7.99968C14.6684 7.12404 14.4965 6.25682 14.1614 5.44784C13.8263 4.63886 13.3346 3.90407 12.7147 3.28568C12.0963 2.66573 11.3615 2.17409 10.5525 1.83898C9.74351 1.50388 8.87629 1.33193 8.00066 1.33301C7.12502 1.33193 6.2578 1.50388 5.44882 1.83898C4.63984 2.17409 3.90505 2.66573 3.28666 3.28568C2.66671 3.90407 2.17506 4.63886 1.83996 5.44784C1.50486 6.25682 1.33291 7.12404 1.33399 7.99968C1.33291 8.87532 1.50486 9.74254 1.83996 10.5515C2.17506 11.3605 2.66671 12.0953 3.28666 12.7137C3.90505 13.3336 4.63984 13.8253 5.44882 14.1604C6.2578 14.4955 7.12502 14.6674 8.00066 14.6663Z"
                    fill="white"
                    stroke="white"
                    stroke-width="1.33333"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.33398 8L7.33398 10L11.334 6"
                    stroke="black"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </mask>
                <g mask="url(#mask0_180_62016)">
                  <path
                    d="M0.000976562 0H16.001V16H0.000976562V0Z"
                    fill="#0088FF"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_180_62016">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.000976562)"
                  />
                </clipPath>
              </defs>
            </svg>
            <p className="text-blue-500 text-sm">Certified</p>
          </span>
        )}
      </div>

      {/* About */}
      <div className="w-full flex flex-col items-start text-left">
        <p className="font-semibold">About</p>
        <p className="text-gray-500 line-clamp-3 sm:line-clamp-4">
          {supplier?.company?.description || ""}
        </p>
      </div>
    </div>
  ));

  return (
    <>
      {(isRecommendedSuppliersLoaded || isSearchInProgress) && (
        <div className="flex flex-row justify-between">
          <span className="recommended-supplier-title">
            Top recommended suppliers
          </span>
          <button
            className="text-[#7B7B7B] font-[19px] mr-10 flex flex-row justify-center items-center"
            onClick={clearSearch}
          >
            <svg
              className="ml-1"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M11.9998 13.9L7.0998 18.8C6.91647 18.9834 6.68314 19.0751 6.3998 19.0751C6.11647 19.0751 5.88314 18.9834 5.6998 18.8C5.51647 18.6167 5.4248 18.3834 5.4248 18.1001C5.4248 17.8167 5.51647 17.5834 5.6998 17.4L10.5998 12.5L5.6998 7.60005C5.51647 7.41672 5.4248 7.18338 5.4248 6.90005C5.4248 6.61672 5.51647 6.38338 5.6998 6.20005C5.88314 6.01672 6.11647 5.92505 6.3998 5.92505C6.68314 5.92505 6.91647 6.01672 7.0998 6.20005L11.9998 11.1L16.8998 6.20005C17.0831 6.01672 17.3165 5.92505 17.5998 5.92505C17.8831 5.92505 18.1165 6.01672 18.2998 6.20005C18.4831 6.38338 18.5748 6.61672 18.5748 6.90005C18.5748 7.18338 18.4831 7.41672 18.2998 7.60005L13.3998 12.5L18.2998 17.4C18.4831 17.5834 18.5748 17.8167 18.5748 18.1001C18.5748 18.3834 18.4831 18.6167 18.2998 18.8C18.1165 18.9834 17.8831 19.0751 17.5998 19.0751C17.3165 19.0751 17.0831 18.9834 16.8998 18.8L11.9998 13.9Z"
                fill="#7B7B7B"
              />
            </svg>
            Clear search
          </button>
        </div>
      )}

      <div
        className="
    mt-4 ml-6 mr-6 grid gap-4 justify-start
    grid-cols-[repeat(auto-fit,minmax(200px,1fr))]
    sm:grid-cols-[repeat(auto-fit,minmax(220px,1fr))]
    md:grid-cols-[repeat(auto-fit,minmax(250px,1fr))]
    lg:grid-cols-[repeat(auto-fit,minmax(300px,1fr))]
    xl:grid-cols-[repeat(auto-fit,minmax(350px,1fr))]
  "
      >
        {suppliersGallery}
      </div>

      {(isRecommendedSuppliersLoaded || isSearchInProgress) && (
        <>
          <div className="explore-suppliers" onClick={handleOpenMoreSuppliers}>
            <span className="recommended-supplier-title explore-suppliers-title">
              Other recommended suppliers
            </span>
          </div>
          {isMoreSuppliersClicked && (
            <div
              className="
    mt-4 ml-6 mr-6 grid gap-4 justify-start
    grid-cols-[repeat(auto-fit,minmax(200px,1fr))]
    sm:grid-cols-[repeat(auto-fit,minmax(220px,1fr))]
    md:grid-cols-[repeat(auto-fit,minmax(250px,1fr))]
    lg:grid-cols-[repeat(auto-fit,minmax(300px,1fr))]
    xl:grid-cols-[repeat(auto-fit,minmax(350px,1fr))]
  "
            >
              {moreSupplierstoExplore}
            </div>
          )}

          {isMoreSuppliersClicked && (
            <div className="explore-suppliers" onClick={clearSearch}>
              <span className="recommended-supplier-title explore-suppliers-title">
                All suppliers
              </span>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default GalleryOfSuppliers;
